module.exports = __webpack_public_path__ + "img/mindwalk.f5a28465.png";